import type { SVGProps } from "react";
export interface ChatHeartIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ChatHeartIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ChatHeartIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M4.133 4.133c4.344-4.345 11.39-4.345 15.734 0s4.344 11.39 0 15.734c-3.477 3.477-8.68 4.17-12.847 2.084l-3.17.762c-1.543.37-2.933-1.02-2.563-2.562l.76-3.173C-.037 12.812.657 7.609 4.133 4.133m14.143 1.592a8.875 8.875 0 0 0-12.55 0 8.88 8.88 0 0 0-1.5 10.562c.136.245.175.534.109.807l-.813 3.382 3.385-.811.207-.03c.207-.01.415.038.599.14a8.875 8.875 0 0 0 10.563-14.05"
      />
      <path
        fill={color}
        d="M13.958 7.875c.935 0 1.746.48 2.29 1.102.546.626.901 1.484.872 2.408l.002.001c-.037 1.226-.758 2.166-1.42 2.852l-.278.28c-.49.48-.96.924-1.365 1.3l-.98.897a1.615 1.615 0 0 1-2.04.099l-.118-.099c-.35-.314-.944-.853-1.633-1.508l-.715-.689c-.719-.703-1.656-1.73-1.698-3.132l.002-.001a3.53 3.53 0 0 1 .874-2.408c.543-.623 1.353-1.102 2.288-1.102.866 0 1.5.308 1.959.688.458-.38 1.093-.688 1.96-.688m0 2.25c-.294 0-.46.102-.588.229a1.4 1.4 0 0 0-.202.26l-.157.295v.001l-.027.05-.023.04a1 1 0 0 1-.174.216 1.1 1.1 0 0 1-.299.217 1.1 1.1 0 0 1-.379.103 1.1 1.1 0 0 1-.478-.053q-.003 0-.005-.002a1 1 0 0 1-.118-.048q-.03-.015-.061-.034l-.022-.011a1.1 1.1 0 0 1-.213-.169 1.1 1.1 0 0 1-.178-.22l-.02-.04a.3.3 0 0 1-.027-.049l-.002-.001c-.097-.203-.2-.4-.357-.556-.128-.126-.294-.228-.589-.228-.148 0-.377.084-.593.331a1.3 1.3 0 0 0-.32.747l-.002.113v.003l.019.161c.073.38.372.813 1.003 1.43l.693.668c.439.417.84.784 1.159 1.075a74 74 0 0 0 1.853-1.743l.25-.254c.539-.567.761-.969.772-1.337v-.003l-.003-.113a1.3 1.3 0 0 0-.32-.747c-.215-.247-.445-.331-.592-.331"
      />
    </svg>
  );
}
